import React from "react";
import { Dialog, Typography, Box, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const CrudModal = ({ handleClose, open, title, maxWidth, children }) => {
  return (
    <Box
      sx={{
        width: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
        p: 2,
      }}
    >
      <Dialog onClose={handleClose} open={open} fullWidth maxWidth={maxWidth}>
        <Box
          sx={{
            width: "100%",
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 20px",
          }}
        >
          <Typography>{title}</Typography>
          <CloseIcon onClick={handleClose} sx={{ cursor: "pointer" }} />
        </Box>
        <Divider />
        <Box
          sx={{ width: "100%", padding: "10px 20px", boxSizing: "border-box" }}
        >
          {children}
        </Box>
      </Dialog>
    </Box>
  );
};

export default CrudModal;
